import { create } from 'zustand';

import { AuthStoreState } from '@/shared/store/auth.store';
import { ProfileStoreState } from '@/shared/store/profile.store';

type AuthFlowStoreStoreState = Pick<AuthStoreState, 'accessToken' | 'account' | 'schemaVersion'> & {
  userName: string | null;
  profile: Partial<ProfileStoreState> | null;
  pin: string | null;
};

type AuthFlowStoreStore = AuthFlowStoreStoreState & {
  setAccessToken: (authTokens: AuthStoreState['accessToken']) => void;
  setAccount: (account: AuthStoreState['account']) => void;
  setUserName: (userName: string | null) => void;
  setSchemaVersion: (schemaVersion: number) => void;
  setProfileData: (profile: Partial<ProfileStoreState>) => void;
  setPin: (pin: string | null) => void;
  clear: () => void;
};

const getInitialState = (): AuthFlowStoreStoreState => ({
  accessToken: null,
  account: null,
  userName: null,
  schemaVersion: null,
  profile: null,
  pin: null,
});

export const useAuthFlowStore = create<AuthFlowStoreStore>((set, get) => ({
  ...getInitialState(),

  setAccessToken: (accessToken) => set({ accessToken }),
  setAccount: (account) => set({ account }),
  setUserName: (userName) => set({ userName }),
  setSchemaVersion: (schemaVersion) => set({ schemaVersion }),
  setPin: (pin) => set({ pin }),

  setProfileData: (profile) =>
    set({
      profile: {
        ...get().profile,
        ...profile,
      },
    }),
  clear: () => set({ ...getInitialState() }),
}));
